import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/common";
import { FormDialog } from "@/components/kids/kidsUi";
import { AMBER, EMOJIS } from "./listsUi";

export const NAME_MSG = "Give your list a name (up to 40 characters)";

// Create (no `list`) or rename/edit a list.
export default function ListForm({ hubId, list, onClose, onSaved }) {
  const [f, setF] = useState({ name: list?.name || "", emoji: list?.emoji || "🛒", store: list?.store || "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    const name = f.name.trim();
    if (!name || name.length > 40) return setError(NAME_MSG);
    setBusy(true);
    try {
      const { data } = list ? await api.patch(`/organizations/${hubId}/lists/${list.id}`, f) : await api.post(`/organizations/${hubId}/lists`, f);
      toast.success(list ? "List updated" : `${data.name} added`);
      onSaved(data);
    } catch (e) { setError(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <FormDialog open onClose={onClose} title={list ? "Edit list" : "New list"} testid="list-form-dialog">
      <div className="space-y-4">
        <Field label="Name" htmlFor="list-name" error={error} errorTestid="list-form-error">
          <input id="list-name" className="q-input" value={f.name} placeholder="Groceries" onChange={(e) => { setF({ ...f, name: e.target.value }); setError(""); }}
            onKeyDown={(e) => e.key === "Enter" && save()} data-testid="list-name-input" />
        </Field>
        <Field label="Emoji">
          <div className="flex flex-wrap gap-1.5" data-testid="list-emoji-picker">
            {EMOJIS.map((em) => (
              <button key={em} type="button" onClick={() => setF({ ...f, emoji: em })} className="inline-flex h-11 w-11 items-center justify-center rounded-xl text-xl transition-transform hover:scale-110"
                style={{ background: f.emoji === em ? `rgba(${AMBER},0.2)` : "rgb(var(--q-raised))", boxShadow: f.emoji === em ? `inset 0 0 0 2px rgb(${AMBER})` : "none" }}
                aria-pressed={f.emoji === em} data-testid={`list-emoji-${em.codePointAt(0).toString(16)}`}>{em}</button>
            ))}
          </div>
        </Field>
        <Field label="Store (optional)" htmlFor="list-store">
          <input id="list-store" className="q-input" maxLength={40} value={f.store} placeholder="Trader Joe's" onChange={(e) => setF({ ...f, store: e.target.value })} data-testid="list-store-input" />
        </Field>
        <div className="flex justify-end gap-2">
          <button className="q-btn q-btn-ghost" onClick={onClose} data-testid="list-form-cancel-btn">Cancel</button>
          <button className="q-btn q-btn-primary" disabled={busy} onClick={save} data-testid="list-form-save-btn">{list ? "Save" : "Create list"}</button>
        </div>
      </div>
    </FormDialog>
  );
}
